import { render, staticRenderFns } from "./SimpleSessionForm.vue?vue&type=template&id=c221fca0&scoped=true&"
import script from "./SimpleSessionForm.vue?vue&type=script&lang=js&"
export * from "./SimpleSessionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c221fca0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
